import {
  IconCloud, IconDrizzle, IconFog, IconMoon, IconPartlyCloud, IconRain, IconStorm, IconSun,
} from './Icon';
import { glyphFor, type Glyph } from '../lib/weather';

/**
 * One weather code, drawn (D67).
 *
 * Its own component rather than a lookup inlined at each call site, because
 * both the Now row and every cell of the Schedule's hourly strip need the same
 * code → glyph decision, and a second copy of that map is a second place for a
 * code to go missing.
 *
 * `aria-hidden` comes from `Icon`'s own wrapper, so the glyph is decoration to
 * a screen reader. Both callers print the label as text beside or under it —
 * the picture never carries meaning on its own.
 */
const GLYPHS: Record<Glyph, (p: { size?: number; className?: string }) => React.ReactElement> = {
  sun: IconSun,
  moon: IconMoon,
  partly: IconPartlyCloud,
  cloud: IconCloud,
  drizzle: IconDrizzle,
  rain: IconRain,
  storm: IconStorm,
  fog: IconFog,
};

export default function WeatherGlyph(
  { code, isDay = true, size = 18 }: { code: number; isDay?: boolean; size?: number },
) {
  const Drawn = GLYPHS[glyphFor(code, isDay)];
  return <Drawn size={size} />;
}
